<template>
    <div>
      <div class="container" :style="{minHeight:minHeight + 'px'}">
        <Head msg="Welcome to Your Vue.js App"/>
        <img style="width:100%;height:300px;" src="./../assets/image/back/dongtaiyaowen_back.jpg" alt="">
        <el-row v-loading="loading">
  <el-col :span="6" style="padding:0 10px 10px 0;">
    <h1 style="padding:10px;color:#2c3e50;font-size:16px;font-weight:bold;">{{title}}<span style="font-size:14px;font-weight:0;">{{title_en}}</span></h1>
    <el-menu
      @select="handleSelect"
      style="border:1px solid #eee"
      :default-active="index"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose">
      <el-menu-item index="1" style="border-bottom:1px solid #eee">
        <i class="el-icon-menu"></i>
        <span slot="title">联盟动态</span>
      </el-menu-item>
      <el-menu-item index="2" style="border-bottom:1px solid #eee">
        <i class="el-icon-document"></i>
        <span slot="title">最新通知</span>
      </el-menu-item>
      <el-menu-item index="3">
        <i class="el-icon-setting"></i>
        <span slot="title">政策法规</span>
      </el-menu-item>
      <!-- <el-menu-item index="4">
        <i class="el-icon-news"></i>
        <span slot="title">会员介绍</span>
      </el-menu-item> -->
    </el-menu>
  </el-col>
  <el-col :span="18">
    <h1 style="padding:10px;color:#2c3e50;text-align:left;font-size:16px;font-weight:bold;">{{title}}<span style="font-size:14px;font-weight:0;">{{title_en}}</span></h1>
    <div style="padding:15px" class="article">
      <ul>
              <li v-for="(item, index) in tableData.list" :key="index">
                <div class="news-content">
                <span style="float:right;display:inline-block;padding-top:7px;">{{timestampToTime(item.uploadTime)}}</span>
                <router-link tag="a" :to="{name:'article',params:{id:item.id}}">{{item.title}}</router-link>
                <!-- <a href="">北京企业技术中心创新服务联盟成立</a> -->
                <!-- <p class="content">{{item.context}}</p>
                <p class="type" v-if="item.classify">[{{item.classify}}]</p>
                <p class="date">{{timestampToTime(item.uploadTime)}}</p> -->
                </div>
              </li>
    </ul>
    <div v-if="!loading && tableData && tableData.list && tableData.list.length === 0" class="empty-state">暂无数据</div>
    <el-pagination
      style="margin:20px 0;"
      background
      layout="prev, pager, next"
      @current-change="handleCurrentChange"
      :page-size="10"
      :total="tableData.total">
</el-pagination>
    </div>
  </el-col>
</el-row>
        </div>
        <Footer msg="Welcome to Your Vue.js App"/>
    </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from "@/components/HelloWorld.vue";
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";
import {articleList} from "@/api/article";

export default {
  data() {
    return {
      minHeight: 0,
      tableData:"",
      loading: false,
      classify:0,
      index:"1",
      title:"联盟动态",
      // title_en:"/ Alliance dynamics"
      title_en:"/ Info"
    };
  },
  methods: {
    timestampToTime(timestamp) {
                const date = new Date(timestamp );//时间戳为10位需*1000，时间戳为13位的话不需乘1000
                const Y = date.getFullYear() + '-';
                const M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
                const D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate())+ ' ';
                const h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours())+ ':';
                const m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes())+ ':';
                const s = date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds();
                return Y+M+D+h+m+s;//时分秒可以根据自己的需求加上
    },
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
        },
        getArticleList(pageNum,pageSize,classify){
          this.loading = true;
          articleList(pageNum,pageSize,classify).then(res => {
            this.tableData = res;
            if(classify === 0){
              this.title = "联盟动态"
              this.title_en = "/ Info";
            }else if(classify === 1){
              this.title = "最新通知";
              this.title_en = "/ News";
            }else if(classify === 2){
              this.title = "政策法规";
              this.title_en = "/ Policy";
            }
            // else{
            //   this.title = "会员介绍";
            //   this.title_en = "/ Member introduction";
            // }
          }).finally(() => {
            this.loading = false;
          });
        },
      handleSelect(index,indexPath){
        if(index == 1){
          this.title = "联盟动态"
          // this.title_en = "/ Alliance dynamics";
          this.title_en = "/ Info";
        }else if(index == 2){
          this.title = "最新通知";
          // this.title_en = "/ The latest notice";
          this.title_en = "/ News";
        }else if(index == 3){
          this.title = "政策法规";
          // this.title_en = "/ A week policy";
          this.title_en = "/ Policy";
        }else if(index==4){
          this.title = "会员介绍";
          // this.title_en = "/ Member introduction";
          this.title_en = "/ Membership";
        }
        this.classify = index - 1;
        this.getArticleList(1,10,this.classify);
      },
      handleCurrentChange(val){
        console.log(this.classify)
        this.getArticleList(val,10,this.classify)
      }

  },
  mounted() {
    this.minHeight = document.documentElement.clientHeight - 200;
    var me = this;
    window.onresize = function() {
      me.minHeight = document.documentElement.clientHeight - 200;
    };
    if(this.$route.params.index){
      this.index = this.$route.params.index;
        this.classify = this.index-1;
      this.getArticleList(1,10,this.index-1)
    }else{
      this.getArticleList(1,10,0);
    }
  },
  components: {
    Head,
    Footer
  }
};
</script>
<style lang="scss" scoped>
.content {
  width: 1200px;
  margin: 0 auto;
}
.el-row{
  width: 1200px;
  margin:30px auto;
}
.article li {
  margin-top:5px;
        /* height: 90px; */
        height: 40px;
        border-bottom: 1px solid #eeeeee;
        .news-content {
          /* height: 75px; */
          width: 100%;
          float: right;
          position: relative;
          a {
            padding: 5px;
            font-size: 18px;
            display: block;
            text-align: left;
            text-decoration: none;
            color: #555555;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          p.content {
            height: 32px;
            width: 100%;
            text-align: left;
            font-size: 16px;
            line-height: 18px;
            color: #999999;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp:2;
            word-break:break-all;
            display:-webkit-box;
            -webkit-box-orient:vertical;
          }
          p.type {
            font-size: 16px;
            color: #999999;
            position: absolute;
            bottom: -7px;
          }
    p.date {
      font-size: 16px;
      color: #999999;
      position: absolute;
      right: 0;
      bottom: -7px;
    }
  }
}

.empty-state {
  padding: 40px 0;
  text-align: center;
  color: #999999;
}

@media (max-width: 767.98px) {
  .el-row {
    width: 100% !important;
    margin: 10px auto !important;
  }
  .el-col-6,
  .el-col-18 {
    width: 100% !important;
  }
  .article li {
    height: auto !important;
    padding: 10px 0 !important;
  }
  .article li .news-content {
    width: 100% !important;
    float: none !important;
  }
  .article li .news-content a {
    font-size: 15px !important;
    white-space: normal !important;
  }
  .el-pagination {
    overflow-x: auto !important;
    white-space: nowrap !important;
    max-width: 100% !important;
    display: flex !important;
    justify-content: center !important;
  }
  .el-pagination .el-pager {
    flex-wrap: wrap !important;
  }
}
</style>
